import { LOCATION } from './regions';
import { ArrayOfObjects } from '../types/ArrayOfObjects';
import { getIterableArrayOfObjects } from '../utils/getIterableArrayOfObjects';
import * as React from 'react';

type PhotoScheme = {
  title: string;
  imageSrc: string;
  description: string;
};

export type SeriaPlusScheme = {
  backgroundImage: string;
  watchObjectsLink: string;
  blockTitle: string;
  title: string | React.JSX.Element;
  media: ArrayOfObjects<PhotoScheme>;
  description: Array<string | React.JSX.Element>;
  disclaimer: string | React.JSX.Element;
};

export type SeriaPlusByLocationScheme = Record<number, SeriaPlusScheme>;

export const seriaPlusByLocation: SeriaPlusByLocationScheme = {
  [LOCATION.MOSCOW_AND_AREA.ID]: {
    backgroundImage: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/background.jpg',
    blockTitle: 'Серия плюс',
    description: [
      <>
        Компания ПИК запустила новую линейку новостроек
        <br />
        повышенного комфорта. Она получила название «Серия плюс».
        <br />
        Здесь собраны особые дома с индивидуальным подходом
        <br />к проектированию.
      </>,
      'Разбираемся, что отличает квартиры «Серии плюс».',
    ],
    disclaimer: (
      <>
        Чем интересна новая линейка компании
        <br />
        ПИК и чем особенны квартиры в таких домах
      </>
    ),
    media: getIterableArrayOfObjects<PhotoScheme>([
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/layout.png',
        title: 'Умные планировки',
        description:
          '«Серия плюс» оказалась не просто удобной, а по-настоящему продуманной планировкой. В студиях можно встретить кухню-нишу, которая занимает мало места. В больших семейных вариантах — ванную с двумя входами. А в конструкции «двушках» и «однушках» — гардеробная, где можно оборудовать кабинет.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/glass.png',
        title: 'Разнообразие остеклений',
        description:
          'Еще одна отличительная черта новой линии — обильные варианты остекления. Здесь можно найти квартиры с окнами в пол, с классическим остеклением и даже с угловыми панорамными окнами во всю стену — чтобы попробовать смелые дизайнерские идеи, чтобы в каждой комнате было стильно, светло и уютно.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/heating.png',
        title: 'Функциональное отопление',
        description:
          'В проектах «Серии плюс» мы делаем горизонтальный разводку отопления — трубы будут проводиться в стяжке пола, а не вдоль стены. Система отопления в проектах будет коллекторной — с ней температуру можно будет регулировать и подстраивать под себя, не мешая соседям. Например, для ремонта можно отключить только один конвектор, не перекрывая отопление в других комнатах и тем более в квартире.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/facing.png',
        title: 'Три варианта отделки',
        description:
          'В «Серии плюс» имеется готовая и предчистовая отделка, а также квартира без ремонта. В случае с готовой отделкой в комнатах уже есть натяжной потолок, обои под покраску и качественный ламинат, пол санузла выложен керамогранитом, а внутри установлена сантехника, включая ванну с карнизом.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/balconies.png',
        title: 'Особенные балконы',
        description:
          'Широкие галерейные балконы по всей квартире, угловые балконы, выходящие на две стороны дома одновременно, или лаконичные французские балконы, соединяющие эстетические требования к дизайнерскому облику дома с функциональностью — в линейке «Серия плюс» можно выбрать любой из вариантов.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/terraces.png',
        title: 'Летние террасы',
        description:
          'Предложение для особых ценителей — открытые террасы, где можно ощутить ритм города и насладиться летним вечером в кругу друзей и близких. Для ограждения терраса используют закаленное стекло — прочное и термостойкое. Он сможет надежно защититься от ветра и не будет закрывать вид на город.',
      },
      {
        imageSrc:
          'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/memorable_architecture.png',
        title: 'Запоминающаяся архитектура',
        description:
          'В «Серии плюс» фасады стали выразительнее и пластичнее, появились новые элементы: эркеры, террасы, балконы и угловые балконы. Первые этажи выделяются особенно, так как их чаще всего рекламируют. Здесь благодаря выбору цветов, материалов и фасадных решений создано уютное пространство для прогулок.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/lobby.jpg',
        title: 'Дизайнерские лобби',
        description:
          'Входные группы делают по специальному дизайн-проекту. В оформлении использования деревянные материалы имеют разные текстуры в гамме натуральных цветов. Благодаря остеклению и высоким потолкам в вестибюле всегда светло и уютно. Вертикальные почтовые ящики в нише с акцентной панелью дополняют современный облик.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/elevators.png',
        title: 'Бесшумные лифты',
        description:
          'Чтобы добиться плавности хода и тишины в лифте, в механизме используются не обычные, а обрезиненные компенсационные цепи. Стены и крыша кабины дополнительно обшивают звукоизолирующим воздействием. Кабины просторные, а их высота увеличена: внутри удобно перевозить велосипеды, коляски и даже мебель.',
      },
      {
        imageSrc:
          'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/underground_floors.png',
        title: 'Подземные этажи',
        description:
          'На цокольных этажах «Серии плюс» предусмотрены отдельные комфортные условия для окружающей среды. Она будет включать в себя просторную подземную парковку с широкими местами и зарядными станциями для электрокаров, кладовые, где можно хранить вещи, и даже парковку для велосипедов и самокатов. Все это создает особый комфорт для жителей',
      },
    ]),
    title: (
      <>
        Что такое
        <br />
        «Серия плюс»
      </>
    ),
    watchObjectsLink:
      'https://www.cian.ru/newobjects/list/?deal_type=sale&engine_version=2&newobject%5B0%5D=1656204&newobject%5B1%5D=20063&newobject%5B2%5D=2159741&newobject%5B3%5D=2251726&newobject%5B4%5D=2764045&newobject%5B5%5D=3499138&newobject%5B6%5D=3842780&newobject%5B7%5D=3961302&newobject%5B8%5D=4601606&newobject%5B9%5D=4726516&newobject%5B10%5D=4958260&offer_type=newobject&region=-1',
  },
  [LOCATION.SPB_AND_AREA.ID]: {
    backgroundImage: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/background.jpg',
    blockTitle: 'Серия плюс',
    description: [
      <>
        Компания ПИК запустила новую линейку новостроек
        <br />
        повышенного комфорта. Она получила название «Серия плюс».
        <br />
        Здесь собраны особые дома с индивидуальным подходом
        <br />к проектированию.
      </>,
      'Разбираемся, что отличает квартиры «Серии плюс».',
    ],
    disclaimer: (
      <>
        Чем интересна новая линейка компании
        <br />
        ПИК и чем особенны квартиры в таких домах
      </>
    ),
    media: getIterableArrayOfObjects<PhotoScheme>([
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/layout.png',
        title: 'Продуманные планировки',
        description:
          '«Серия плюс» оказалась не просто удобной, а по-настоящему продуманной планировкой. В студиях можно встретить кухню-нишу, которая занимает мало места. В больших семейных вариантах — ванную с двумя входами. А в конструкции «двушках» и «однушках» — гардеробная, где можно оборудовать кабинет.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/glass.png',
        title: 'Разнообразие остеклений',
        description:
          'Еще одна отличительная черта новой линии — обильные варианты остекления. Здесь можно найти квартиры с окнами в пол, с классическим остеклением и даже с угловыми панорамными окнами во всю стену — чтобы попробовать смелые дизайнерские идеи, чтобы в каждой комнате было стильно, светло и уютно.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/heating.png',
        title: 'Функциональное отопление',
        description:
          'В проектах «Серии плюс» мы делаем горизонтальный разводку отопления — трубы будут проводиться в стяжке пола, а не вдоль стены. Система отопления в проектах будет коллекторной — с ней температуру можно будет регулировать и подстраивать под себя, не мешая соседям. Например, для ремонта можно отключить только один конвектор, не перекрывая отопление в других комнатах и тем более в квартире.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/facing.png',
        title: 'Три варианта отделки',
        description:
          'В «Серии плюс» имеется готовая и предчистовая отделка, а также квартира без ремонта. В случае с готовой отделкой в комнатах уже есть натяжной потолок, обои под покраску и качественный ламинат, пол санузла выложен керамогранитом, а внутри установлена сантехника, включая ванну с карнизом.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/balconies.png',
        title: 'Особенные балконы',
        description:
          'Широкие галерейные балконы по всей квартире, угловые балконы, выходящие на две стороны дома одновременно, или лаконичные французские балконы, соединяющие эстетические требования к дизайнерскому облику дома с функциональностью — в линейке «Серия плюс» можно выбрать любой из вариантов.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/terraces.png',
        title: 'Летние террасы',
        description:
          'Предложение для особых ценителей — открытые террасы, где можно ощутить ритм города и насладиться летним вечером в кругу друзей и близких. Для ограждения терраса используют закаленное стекло — прочное и термостойкое. Он сможет надежно защититься от ветра и не будет закрывать вид на город.',
      },
      {
        imageSrc:
          'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/memorable_architecture.png',
        title: 'Запоминающаяся архитектура',
        description:
          'В «Серии плюс» фасады стали выразительнее и пластичнее, появились новые элементы: эркеры, террасы, балконы и угловые балконы. Первые этажи выделяются особенно, так как их чаще всего рекламируют. Здесь благодаря выбору цветов, материалов и фасадных решений создано уютное пространство для прогулок.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/lobby.jpg',
        title: 'Дизайнерские лобби',
        description:
          'Входные группы делают по специальному дизайн-проекту. В оформлении использования деревянные материалы имеют разные текстуры в гамме натуральных цветов. Благодаря остеклению и высоким потолкам в вестибюле всегда светло и уютно. Вертикальные почтовые ящики в нише с акцентной панелью дополняют современный облик.',
      },
      {
        imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/elevators.png',
        title: 'Бесшумные лифты',
        description:
          'Чтобы добиться плавности хода и тишины в лифте, в механизме используются не обычные, а обрезиненные компенсационные цепи. Стены и крыша кабины дополнительно обшивают звукоизолирующим воздействием. Кабины просторные, а их высота увеличена: внутри удобно перевозить велосипеды, коляски и даже мебель.',
      },
      {
        imageSrc:
          'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus/underground_floors.png',
        title: 'Подземные этажи',
        description:
          'На цокольных этажах «Серии плюс» предусмотрены отдельные комфортные условия для окружающей среды. Она будет включать в себя просторную подземную парковку с широкими местами и зарядными станциями для электрокаров, кладовые, где можно хранить вещи, и даже парковку для велосипедов и самокатов. Все это создает особый комфорт для жителей',
      },
    ]),
    title: (
      <>
        Что такое
        <br />
        «Серия плюс»
      </>
    ),
    watchObjectsLink:
      'https://spb.cian.ru/newobjects/list/?deal_type=sale&engine_version=2&newobject%5B0%5D=3878565&newobject%5B1%5D=4065973&offer_type=newobject&region=-2',
  },
};
